import {HTTP} from '../../../../services/api-service.js';
import commonObj from '../../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;

const stockBalanceEnquiryStore = {
    namespaced: true,
    actions:{
        getStockBalance({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/stock/StockBalance', param).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        },
    }
};
export default stockBalanceEnquiryStore;